import {SmartComponent} from "smart-component-js";

class ActivitiesListComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.endpoint = `/api/1.0/site/mydonnad/campaign/dlover2025/user/activities`;
        this.init();
    }

    getActivities() {
        return youserxp.ajax(this.endpoint, {method: 'GET', auth: true}).then(
            (data) => {
                this.element.classList.remove('loading');
                this.activities = data.body.results;

                if (this.activities.length > 0) {
                    this.createItems();
                } else {
                    this.createNoActvities();
                }
            },
            (err) => {
                console.log(err);
                this.element.classList.remove('loading')
            },
        );
    }

    createItems() {
        const items = this.activities.map((item) => {
            const formattedDate = this.formatDateLocal(item.date);

            // --- Handle points display ---
            const renderPoints = () => {
                if (item.type === 'receipt-approved') {
                    return `<span class="green">+ ${item.earnedPoints} <b>${(item.earnedPoints === 1) ? 'punto Cuore' : 'punti Cuore'}</b></span><br />`;
                }
                if (item.type === 'receipt-awaiting-approval') {
                    return `<span class="orange-red tooltip">In approvazione
                  <span class="tooltip-text">${GENERIC_TRANSLATIONS.receiptInApproval}</span>
                </span>`;
                }
                if (item.type === 'receipt-rejected') {
                    return `<span class="orange-red tooltip">${GENERIC_TRANSLATIONS.receiptRejectedLabel}
                  <span class="tooltip-text">${GENERIC_TRANSLATIONS.receiptRejectedTooltip}</span>
                </span>`;
                }
                if (!item.type) {
                    return `<span class="green">+ ${item.earnedPoints} <b>punti Cuore</b></span><br />`;
                }
                return '';
            };

            // --- Handle special "customer-service" where earnedPoints<0 case ---
            if (item.icon === 'customer-service' && item.earnedPoints < 0) {
                return `
        <div class="activities-list__activity-item">
          <div class="activities-list__details">
            <div class="activities-list__icon">
             <img src="/fe-web/img/donnad/icons/punti-rimossi.svg"/>
            </div>
            <div class="activities-list__copy">
              <div class="activities-list__date">${formattedDate}</div>
              <div class="activities-list__title">${item.title}</div>
            </div>
          </div>
          <div class="activities-list__points">
            <span class="orange-red">${item.earnedPoints} <b>punti Cuore</b></span>
          </div>
        </div>
      `;
            }
            if (item.icon === 'customer-service' && item.earnedPoints > 0) {
                return `
        <div class="activities-list__activity-item">
          <div class="activities-list__details">
            <div class="activities-list__icon">
             <img src="/fe-web/img/donnad/icons/punti-rimossi.svg"/>
            </div>
            <div class="activities-list__copy">
              <div class="activities-list__date">${formattedDate}</div>
              <div class="activities-list__title">${item.title}</div>
            </div>
          </div>
          <div class="activities-list__points">
               <span class="green">+ ${item.earnedPoints} <b>punti Cuore</b></span><br />
          </div>
        </div>
      `;
            }

            // --- Handle special "Request-prize" case ---
            if (item.icon === 'request-prize') {
                return `
        <div class="activities-list__activity-item">
          <div class="activities-list__details">
            <div class="activities-list__icon">
             <img src="/fe-web/img/donnad/icons/icon-premio-richiesto.png"/>
            </div>
            <div class="activities-list__copy">
              <div class="activities-list__date">${formattedDate}</div>
              <div class="activities-list__title">${item.title}</div>
              <div class="activities-list__subtitle">${item.subtitle || ''}</div>
              <div class="activities-list__status ${item.type === 'APPROVED' ? 'greenBg' : item.type === 'REJECTED' ? 'redBg' : 'greyBg'}">${item.type || ''}</div>
            </div>
          </div>
          <div class="activities-list__points">
            <span class="orange-red">${item.earnedPoints} <b>punti Cuore</b></span>
          </div>
        </div>
      `;
            }

            // --- Default case ---
            return `
      <div class="activities-list__activity-item">
        <div class="activities-list__details">
          <div class="activities-list__icon">
            <img src="${item.icon}" alt="" />
          </div>
          <div class="activities-list__copy">
            <div class="activities-list__date">${formattedDate}</div>
            <div class="activities-list__title">${item.title}</div>
            <div class="activities-list__subtitle">${item.subtitle || ''}</div>
          </div>
        </div>
        <div class="activities-list__points">${renderPoints()}</div>
      </div>
    `;
        }).join('');

        this.element.querySelector('.activities-list__wrapper').insertAdjacentHTML('beforeend', items);
    }


    createNoActvities() {
        let html = '';

        html += `
         <div class="activities-list__empty-card text-center">
            <div class="text"><b>Non hai ancora fatto nessuna azione</b></div>
            <div class="text">Inizia subito a guadagnare punti!</div>
            <div class="primary-button mt-30">
                <a href="reserved/dlovers">Guadagna punti</a>
            </div>
                
         </div>
        `
        this.element.querySelector('.activities-list__wrapper').insertAdjacentHTML('beforeend', html);
    }

    formatDateLocal(isoString) {
        const date = new Date(isoString);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${day}/${month}/${year} - ${hours}:${minutes}`;
    }

    init() {
        this.element.classList.add('loading');
        this.getActivities();
    }
}

export default ActivitiesListComponent;